import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BarChart from 'components/@common/Charts/BarChart';
import { PrintViewContext } from '../../../../providers/PrintViewProvider';

interface TotalActiveStudentsChartProps {
  activeStudentsSeries: number[];
  totalStudentsSeries: number[];
  labels: string[];
  onClick?: (index: number) => void;
}

const TotalActiveStudentsChart: React.FC<TotalActiveStudentsChartProps> = ({
  activeStudentsSeries,
  totalStudentsSeries,
  labels,
  onClick
}) => {
  const { t } = useTranslation('Reports');
  const { fullChartWidth } = useContext(PrintViewContext);

  return (
    <BarChart
      height={250}
      width={fullChartWidth}
      onClick={onClick}
      series={[
        {
          name: t('Total Licensed Students'),
          data: totalStudentsSeries
        },
        {
          name: t('Active Students'),
          data: activeStudentsSeries
        }
      ]}
      options={{
        colors: ['#A6C1E4', '#50B755'],
        yaxis: {
          decimalsInFloat: 0,
          title: {
            offsetX: -2,
            text: 'No of Students',
            style: {
              color: '#373D3F',
              fontSize: '12px',
              fontWeight: 700,
              fontFamily: 'futura-pt'
            }
          }
        },
        xaxis: {
          categories: labels,
          labels: {
            offsetY: -4,
            style: {
              colors: '#373D3F',
              fontSize: '10px',
              fontFamily: 'futura-pt'
            }
          },
          axisTicks: { show: false }
        },
        legend: {
          offsetY: 2,
          horizontalAlign: 'left'
        },
        dataLabels: { enabled: false }
      }}
    />
  );
};

export default React.memo(TotalActiveStudentsChart);
